// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* View User Modal Styles - Redesigned */

.view-user-modal {
    max-width: 1100px;
    max-height: 90vh;
    overflow-y: auto;
    font-family: 'Outfit', sans-serif;
    color: #1a1a1a;
    background: #fff;
    border-radius: 20px;
}

.view-user-modal .modal-body {
    padding: 30px;
}

.user-view-shell {
    display: grid;
    grid-gap: 24px;
    gap: 24px;
}

/* Hero Section */
.user-hero {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    background: linear-gradient(135deg, #fff5f0 0%, #fff 100%);
    border: 1px solid #fed7aa;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(255, 107, 53, 0.05);
}

.identity-block {
    display: flex;
    align-items: center;
    gap: 16px;
}

.avatar-ring {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ff6b35, #ff9f43);
    color: #fff;
    display: grid;
    place-items: center;
    font-weight: 700;
    font-size: 24px;
    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
}

.identity-block h3 {
    margin: 0 0 4px 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: #1f2937;
}

.identity-block p {
    margin: 0;
    color: #4b5563;
    font-size: 0.95rem;
}

.chip-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.chip {
    padding: 6px 12px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    border: 1px solid transparent;
}

.chip-success {
    background: #dcfce7;
    color: #166534;
    border-color: #bbf7d0;
}

.chip-warning {
    background: #fef9c3;
    color: #854d0e;
    border-color: #fde047;
}

.chip-danger {
    background: #fee2e2;
    color: #991b1b;
    border-color: #fecaca;
}

.chip-info {
    background: #e0f2fe;
    color: #075985;
    border-color: #bae6fd;
}

/* KPI Cards */
.kpi-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-gap: 16px;
    gap: 16px;
}

.kpi-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    padding: 20px;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.kpi-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);
    border-color: #fed7aa;
}

.kpi-card span {
    color: #6b7280;
    font-size: 0.85rem;
    font-weight: 500;
    display: block;
    margin-bottom: 8px;
}

.kpi-card strong {
    font-size: 1.5rem;
    color: #111827;
    font-weight: 800;
}

/* Panels */
.panel-grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 20px;
    gap: 20px;
}

.panel-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);
    grid-column: span 4;
}

@media (max-width: 1024px) {
    .panel-card {
        grid-column: span 6;
    }
}

@media (max-width: 768px) {
    .panel-card {
        grid-column: span 12;
    }
}

.panel-card h4 {
    margin: 0 0 16px 0;
    font-size: 1.1rem;
    font-weight: 700;
    color: #111827;
    display: flex;
    align-items: center;
    gap: 8px;
}

.digio-panel .detail-list {
    margin-bottom: 16px;
}

.digio-form {
    display: grid;
    grid-gap: 12px;
    gap: 12px;
}

.digio-field {
    display: grid;
    grid-gap: 6px;
    gap: 6px;
}

.digio-field label {
    font-size: 0.85rem;
    color: #6b7280;
    font-weight: 600;
}

.digio-field input,
.digio-field select {
    padding: 10px 12px;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    font-size: 0.9rem;
}

.digio-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: 12px;
    gap: 12px;
}

.digio-actions {
    display: flex;
    justify-content: flex-end;
}

.btn-primary {
    background: linear-gradient(135deg, #ff6b35, #ff9f43);
    color: #fff;
    border: none;
    padding: 10px 16px;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-primary:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 8px 16px rgba(255, 107, 53, 0.25);
}

.digio-message {
    margin: 0;
    font-size: 0.85rem;
    color: #065f46;
}

@media (max-width: 768px) {
    .digio-grid {
        grid-template-columns: 1fr;
    }
}

.detail-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #f3f4f6;
}

.detail-row:last-child {
    padding-bottom: 0;
    border-bottom: none;
}

/* Document Grid */
.doc-grid-section {
    grid-column: span 12;
}

.doc-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 16px;
    gap: 16px;
    margin-top: 16px;
}

.doc-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    transition: all 0.2s ease;
    cursor: pointer;
    position: relative;
    height: 160px;
}

.doc-card:hover {
    background: #fff;
    border-color: #ff6b35;
    transform: translateY(-4px);
    box-shadow: 0 10px 25px rgba(255, 107, 53, 0.15);
}

.doc-icon {
    font-size: 40px;
    margin-bottom: 12px;
    color: #cbd5e1;
    transition: all 0.2s;
}

.doc-card:hover .doc-icon {
    color: #ff6b35;
    transform: scale(1.1);
}

.doc-info {
    width: 100%;
}

.doc-name {
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
    display: block;
}

.doc-meta {
    font-size: 11px;
    color: #94a3b8;
}

.view-btn-overlay {
    position: absolute;
    bottom: 16px;
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.2s ease;
}

.doc-card:hover .view-btn-overlay {
    opacity: 1;
    transform: translateY(0);
}

.doc-card:hover .doc-info {
    opacity: 0.1;
    /* Fade text on hover to show button clearly */
}

.btn-view-doc {
    background: #ff6b35;
    color: #fff;
    border: none;
    padding: 6px 16px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(255, 107, 53, 0.3);
}

.upload-area {
    border: 2px dashed #cbd5e1;
    border-radius: 12px;
    padding: 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #f8fafc;
    transition: all 0.2s;
    height: 160px;
}

.upload-area:hover {
    border-color: #ff6b35;
    background: #fff5f0;
}

.upload-icon {
    font-size: 32px;
    color: #94a3b8;
    margin-bottom: 8px;
}

.upload-area p {
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    margin: 0;
}

.doc-empty-state {
    grid-column: 1 / -1;
    text-align: center;
    padding: 40px;
    background: #f9fafb;
    border-radius: 12px;
    color: #6b7280;
    font-style: italic;
}

/* CIBIL Score Badge in User View Modal */
.cibil-score-badge {
    text-align: center;
    padding: 0 20px;
    border-left: 2px solid #e5e7eb;
    border-right: 2px solid #e5e7eb;
    margin: 0 10px;
    min-width: 100px;
}

.cibil-score-badge .cibil-label {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;
    color: #6b7280;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}

.cibil-score-badge .cibil-value {
    font-size: 24px;
    font-weight: 800;
    line-height: 1.2;
}

@media (max-width: 768px) {
    .user-hero {
        flex-direction: column;
        align-items: flex-start;
    }

    .cibil-score-badge {
        border: none;
        padding: 0;
        margin: 10px 0;
        text-align: left;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminModals.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,cAAS;IAAT,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,0DAA0D;IAC1D,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAS;IAAT,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,sCAAsC;IACtC,cAAS;IAAT,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAS;IAAT,SAAS;AACb;;AAEA;IACI,aAAa;IACb,aAAQ;IAAR,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,cAAS;IAAT,SAAS;AACb;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,qDAAqD;AACzD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,cAAS;IAAT,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,cAAc;QACd,gBAAgB;IACpB;AACJ","sourcesContent":["/* View User Modal Styles - Redesigned */\n\n.view-user-modal {\n    max-width: 1100px;\n    max-height: 90vh;\n    overflow-y: auto;\n    font-family: 'Outfit', sans-serif;\n    color: #1a1a1a;\n    background: #fff;\n    border-radius: 20px;\n}\n\n.view-user-modal .modal-body {\n    padding: 30px;\n}\n\n.user-view-shell {\n    display: grid;\n    gap: 24px;\n}\n\n/* Hero Section */\n.user-hero {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n    background: linear-gradient(135deg, #fff5f0 0%, #fff 100%);\n    border: 1px solid #fed7aa;\n    border-radius: 16px;\n    padding: 24px;\n    box-shadow: 0 4px 20px rgba(255, 107, 53, 0.05);\n}\n\n.identity-block {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.avatar-ring {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #ff6b35, #ff9f43);\n    color: #fff;\n    display: grid;\n    place-items: center;\n    font-weight: 700;\n    font-size: 24px;\n    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);\n}\n\n.identity-block h3 {\n    margin: 0 0 4px 0;\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #1f2937;\n}\n\n.identity-block p {\n    margin: 0;\n    color: #4b5563;\n    font-size: 0.95rem;\n}\n\n.chip-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.chip {\n    padding: 6px 12px;\n    border-radius: 999px;\n    font-size: 13px;\n    font-weight: 600;\n    border: 1px solid transparent;\n}\n\n.chip-success {\n    background: #dcfce7;\n    color: #166534;\n    border-color: #bbf7d0;\n}\n\n.chip-warning {\n    background: #fef9c3;\n    color: #854d0e;\n    border-color: #fde047;\n}\n\n.chip-danger {\n    background: #fee2e2;\n    color: #991b1b;\n    border-color: #fecaca;\n}\n\n.chip-info {\n    background: #e0f2fe;\n    color: #075985;\n    border-color: #bae6fd;\n}\n\n/* KPI Cards */\n.kpi-row {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n}\n\n.kpi-card {\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 16px;\n    padding: 20px;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);\n}\n\n.kpi-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);\n    border-color: #fed7aa;\n}\n\n.kpi-card span {\n    color: #6b7280;\n    font-size: 0.85rem;\n    font-weight: 500;\n    display: block;\n    margin-bottom: 8px;\n}\n\n.kpi-card strong {\n    font-size: 1.5rem;\n    color: #111827;\n    font-weight: 800;\n}\n\n/* Panels */\n.panel-grid {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    gap: 20px;\n}\n\n.panel-card {\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 16px;\n    padding: 24px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);\n    grid-column: span 4;\n}\n\n@media (max-width: 1024px) {\n    .panel-card {\n        grid-column: span 6;\n    }\n}\n\n@media (max-width: 768px) {\n    .panel-card {\n        grid-column: span 12;\n    }\n}\n\n.panel-card h4 {\n    margin: 0 0 16px 0;\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #111827;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.digio-panel .detail-list {\n    margin-bottom: 16px;\n}\n\n.digio-form {\n    display: grid;\n    gap: 12px;\n}\n\n.digio-field {\n    display: grid;\n    gap: 6px;\n}\n\n.digio-field label {\n    font-size: 0.85rem;\n    color: #6b7280;\n    font-weight: 600;\n}\n\n.digio-field input,\n.digio-field select {\n    padding: 10px 12px;\n    border-radius: 10px;\n    border: 1px solid #e5e7eb;\n    font-size: 0.9rem;\n}\n\n.digio-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n}\n\n.digio-actions {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.btn-primary {\n    background: linear-gradient(135deg, #ff6b35, #ff9f43);\n    color: #fff;\n    border: none;\n    padding: 10px 16px;\n    border-radius: 10px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.btn-primary:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.btn-primary:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 8px 16px rgba(255, 107, 53, 0.25);\n}\n\n.digio-message {\n    margin: 0;\n    font-size: 0.85rem;\n    color: #065f46;\n}\n\n@media (max-width: 768px) {\n    .digio-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.detail-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.detail-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #f3f4f6;\n}\n\n.detail-row:last-child {\n    padding-bottom: 0;\n    border-bottom: none;\n}\n\n/* Document Grid */\n.doc-grid-section {\n    grid-column: span 12;\n}\n\n.doc-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 16px;\n    margin-top: 16px;\n}\n\n.doc-card {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    transition: all 0.2s ease;\n    cursor: pointer;\n    position: relative;\n    height: 160px;\n}\n\n.doc-card:hover {\n    background: #fff;\n    border-color: #ff6b35;\n    transform: translateY(-4px);\n    box-shadow: 0 10px 25px rgba(255, 107, 53, 0.15);\n}\n\n.doc-icon {\n    font-size: 40px;\n    margin-bottom: 12px;\n    color: #cbd5e1;\n    transition: all 0.2s;\n}\n\n.doc-card:hover .doc-icon {\n    color: #ff6b35;\n    transform: scale(1.1);\n}\n\n.doc-info {\n    width: 100%;\n}\n\n.doc-name {\n    font-size: 13px;\n    font-weight: 600;\n    color: #334155;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-bottom: 4px;\n    display: block;\n}\n\n.doc-meta {\n    font-size: 11px;\n    color: #94a3b8;\n}\n\n.view-btn-overlay {\n    position: absolute;\n    bottom: 16px;\n    opacity: 0;\n    transform: translateY(10px);\n    transition: all 0.2s ease;\n}\n\n.doc-card:hover .view-btn-overlay {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.doc-card:hover .doc-info {\n    opacity: 0.1;\n    /* Fade text on hover to show button clearly */\n}\n\n.btn-view-doc {\n    background: #ff6b35;\n    color: #fff;\n    border: none;\n    padding: 6px 16px;\n    border-radius: 20px;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    box-shadow: 0 4px 10px rgba(255, 107, 53, 0.3);\n}\n\n.upload-area {\n    border: 2px dashed #cbd5e1;\n    border-radius: 12px;\n    padding: 20px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    background: #f8fafc;\n    transition: all 0.2s;\n    height: 160px;\n}\n\n.upload-area:hover {\n    border-color: #ff6b35;\n    background: #fff5f0;\n}\n\n.upload-icon {\n    font-size: 32px;\n    color: #94a3b8;\n    margin-bottom: 8px;\n}\n\n.upload-area p {\n    font-size: 13px;\n    font-weight: 600;\n    color: #64748b;\n    margin: 0;\n}\n\n.doc-empty-state {\n    grid-column: 1 / -1;\n    text-align: center;\n    padding: 40px;\n    background: #f9fafb;\n    border-radius: 12px;\n    color: #6b7280;\n    font-style: italic;\n}\n\n/* CIBIL Score Badge in User View Modal */\n.cibil-score-badge {\n    text-align: center;\n    padding: 0 20px;\n    border-left: 2px solid #e5e7eb;\n    border-right: 2px solid #e5e7eb;\n    margin: 0 10px;\n    min-width: 100px;\n}\n\n.cibil-score-badge .cibil-label {\n    display: block;\n    font-size: 11px;\n    text-transform: uppercase;\n    font-weight: 700;\n    color: #6b7280;\n    letter-spacing: 0.5px;\n    margin-bottom: 2px;\n}\n\n.cibil-score-badge .cibil-value {\n    font-size: 24px;\n    font-weight: 800;\n    line-height: 1.2;\n}\n\n@media (max-width: 768px) {\n    .user-hero {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .cibil-score-badge {\n        border: none;\n        padding: 0;\n        margin: 10px 0;\n        text-align: left;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
